<template>
  <div v-loading="loading" class="salesOrderPreview">
    <el-row style="text-align: left; margin-bottom: 5px">
      <!--      <el-button type="danger" style="margin-top: 5px">关闭</el-button>-->
      <el-button type="success" style="margin-top: 5px" :loading="printSalesOrderLoading" @click="printSalesOrderVO">打印</el-button>
      <el-button type="success" style="margin-top: 5px" :loading="printContractDeptLoading" @click="printContractDept">合同流程附件打印</el-button>
      <el-button type="success" style="margin-top: 5px" :loading="printCableLoading" @click="printCable">线缆合同打印</el-button>
      <el-button type="primary" style="margin-top: 5px" @click="$refs.editMaterialNo.open(billId, billType)">发货单</el-button>
      <el-button
          type="primary"
          style="margin-top: 5px"
          :loading="exportExcelOfThsInfoLoading"
          @click="exportExcelOfThsInfo"
      >
        导出蒂升项目信息表
      </el-button
      >
      <el-button type="primary" style="margin-top: 5px" @click="ardHandle">ARD参数</el-button>
      <el-button type="primary" style="margin-top: 5px" @click="exportProduction">导出生产订单</el-button>
    </el-row>
    <el-tabs type="border-card">
      <el-tab-pane label="主表信息">
        <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">出厂编号:</td>
            <td style="width: 23%">{{salesOrder.salesOrderNO}}</td>
            <td class="tableLabel">制单人:</td>
            <td style="width: 23%">{{salesOrder.creatorName}}</td>
            <td class="tableLabel">制单时间:</td>
            <td>{{salesOrder.createDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">合同编号:</td>
            <td>{{salesOrder.clientContractNO}}</td>
            <td class="tableLabel">订单类型:</td>
            <td>{{salesOrder.orderType}}</td>
            <td class="tableLabel">提交时间:</td>
            <td>{{salesOrder.submitTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">项目名称:</td>
            <td>{{salesOrder.projectName}}</td>
            <td class="tableLabel">SAP订单号:</td>
            <td>{{salesOrder.sapsalesOrderNO}}</td>
            <td class="tableLabel">项目类型:</td>
            <td>{{salesOrder.subContract}}</td>
          </tr>
          <tr>
            <td class="tableLabel">客户名称:</td>
            <td>{{salesOrder.invoiceName}}</td>
            <td class="tableLabel">联系人:</td>
            <td>{{salesOrder.contact}}</td>
            <td class="tableLabel">电话:</td>
            <td>{{salesOrder.telephone}}</td>
          </tr>
          <tr>
            <td class="tableLabel">要求交期:</td>
            <td>{{salesOrder.deliveryDate}}</td>
            <td class="tableLabel">安装地点:</td>
            <td>{{salesOrder.setupPlace}}</td>
            <td class="tableLabel">订单种类:</td>
            <td v-if="salesOrder.projectCategory === 1">整梯</td>
            <td v-else-if="salesOrder.projectCategory === 2">改造</td>
            <td v-else-if="salesOrder.projectCategory === 3">配件</td>
            <td v-else>其他</td>
          </tr>
          <tr>
            <td class="tableLabel">最终交期:</td>
            <td>{{salesOrder.finalDeliveryDate}}</td>
            <td class="tableLabel">SAP订单类型:</td>
            <td>{{salesOrder.saleOrderTypeCode}}</td>
            <td class="tableLabel">SAP客户类型:</td>
            <td>{{salesOrder.customerTypeCode}}</td>
          </tr>
          <tr>
            <td class="tableLabel">送货地点:</td>
            <td colspan="3">{{salesOrder.deliveryPlace}}</td>
            <td class="tableLabel">含控制柜:</td>
            <td>{{salesOrder.includeControlBox ? "是" : "否"}}</td>
          </tr>
          <tr>
            <td class="tableLabel">付款方式:</td>
            <td>{{salesOrder.paymentMethod}}</td>
            <td class="tableLabel">电气:</td>
            <td>{{salesOrder.needDQTech ? "是" : "否"}}</td>
            <td class="tableLabel">部件:</td>
            <td>{{salesOrder.needBJTech ? "是" : "否"}}</td>
          </tr>
          <tr>
            <td class="tableLabel">运输类型:</td>
            <td>{{salesOrder.deliveryStatus ? "是" : "否"}}</td>
            <td class="tableLabel">其他运输:</td>
            <td colspan="3">{{salesOrder.otherTransport}}</td>
          </tr>
          <tr>
            <td class="tableLabel">包装箱选择:</td>
            <td>{{salesOrder.shippingMark}}</td>
            <td class="tableLabel">特殊包装要求:</td>
            <td colspan="3">{{salesOrder.box}}</td>
          </tr>
          <tr>
            <td class="tableLabel">包装备注:</td>
            <td colspan="5">{{salesOrder.note}}</td>
          </tr>
          <tr>
            <td class="tableLabel">关键物料:</td>
            <td colspan="5" style="padding: 4px">
              <el-input v-model="salesOrder.keySAPMaterialDesc" size="mini" style="width: 300px; margin-right: 10px"/>
              <el-button size="mini" type="primary" @click="$refs.selectMaterial.open()">选择</el-button>
              <el-button size="mini" type="primary">删除</el-button>
              <el-button size="mini" type="primary">保存</el-button>
              <material-management-select ref="selectMaterial" @select="selectMaterial"/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">备注:</td>
            <td colspan="5">{{salesOrder.note}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="费用清单">
        <div v-if="salesOrder.salesOrderMaterialVOes && salesOrder.salesOrderMaterialVOes.length">
          <div v-if="salesOrder.priceVisible === true">
            <table class="gridtable" style="width: 100%; margin-top: 10px">
              <tr>
                <td>总费用：{{salesOrder.totalMoney}}</td>
                <td>电器控制器：0</td>
                <td>新时达电梯控制器嵌入式软件V1.0：0</td>
                <td>控制柜：0</td>
                <td>系统板：0</td>
              </tr>
              <tr>
                <td>配件：0</td>
                <td>电梯控制驱动一体机：0</td>
                <td>新时达电梯控制驱动一体机嵌入式软件 V1.0：0</td>
                <td colspan="2" align="center">
                  <el-button type="primary" :icon="isHidden ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="changeIsHidden">
                    {{isHidden ? "全部隐藏" : "全部展开"}}
                  </el-button>
                </td>
              </tr>
            </table>
            <el-table ref="multipleTable" :data="salesOrder.salesOrderMaterialVOes" style="width: 100%; margin-top: 20px">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table :data="props.row.salesOrderMaterialPropertyVOes" style="width: 90%; margin: 0 auto">
                    <el-table-column label="特性名称" prop="propertyDisplayName"/>
                    <el-table-column label="特性值" prop="propertyDisplayValue"/>
                    <el-table-column label="审批意见" prop="approveNote"/>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="materialName" width="130" label="产品名称"/>
              <el-table-column prop="specification" label="规格型号"/>
              <el-table-column prop="quantity" width="60" label="数量"/>
              <el-table-column prop="priceType" label="价格类型">
                <template slot-scope="scope">
                  <div v-if="scope.row.priceType === 5">面价</div>
                  <div v-else-if="scope.row.priceType === 10">销售员价</div>
                  <div v-else-if="scope.row.priceType === 20">区总价</div>
                  <div v-else-if="scope.row.priceType === 30">总监价</div>
                  <div v-else-if="scope.row.priceType === 40">客户执行价</div>
                  <div v-else-if="scope.row.priceType === 50">按单价</div>
                  <div v-else style="color: red">未定价</div>
                </template>
              </el-table-column>
              <el-table-column label="定价" width="150px">
                <template v-if="salesOrder.costPriceVisible === true" slot-scope="scope">
                  <div>成本价：{{scope.row.costPrice}}</div>
                  <div>成本结算价：{{scope.row.settlementCostPrice}}</div>
                  <div>标准价：{{scope.row.price}}</div>
                  <div>销售结算价：{{scope.row.settlementSalesPrice}}</div>
                </template>
                <template v-else>
                  <span>***</span>
                </template>
              </el-table-column>
              <el-table-column prop="strikePrice" label="执行价"/>
              <el-table-column prop="price" label="单价"/>
              <el-table-column prop="processingFeePrice" label="加工费"/>
              <el-table-column prop="total" label="金额(含税)"/>
              <el-table-column prop="additionTotal" width="120" label="软硬件及配件"/>
              <el-table-column prop="note" width="300" style="color:red;" label="备注">
                <template slot-scope="scope">
                  <div style="color: red">{{scope.row.note}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="approveNote" label="审批意见"/>
            </el-table>
          </div>
          <div v-else>
            <table class="gridtable" style="width: 100%; margin-top: 10px">
              <tr>
                <td>总费用：***</td>
                <td>电器控制器：***</td>
                <td>新时达电梯控制器嵌入式软件V1.0：***</td>
                <td>控制柜：***</td>
                <td>系统板：***</td>
              </tr>
              <tr>
                <td>配件：***</td>
                <td>电梯控制驱动一体机：***</td>
                <td>新时达电梯控制驱动一体机嵌入式软件 V1.0：***</td>
                <td colspan="2" align="center">
                  <el-button type="primary" :icon="isHidden ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="changeIsHidden">
                    {{isHidden ? "全部隐藏" : "全部展开"}}
                  </el-button>
                </td>
              </tr>
            </table>
            <el-table ref="multipleTable" :data="salesOrder.salesOrderMaterialVOes" style="width: 100%; margin-top: 20px">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table :data="props.row.salesOrderMaterialPropertyVOes" style="width: 90%; margin: 0 auto">
                    <el-table-column label="特性名称" prop="propertyDisplayName"/>
                    <el-table-column label="特性值" prop="propertyDisplayValue"/>
                    <el-table-column label="审批意见" prop="approveNote"/>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="materialName" width="130" label="产品名称"/>
              <el-table-column prop="specification" label="规格型号"/>
              <el-table-column prop="quantity" width="60" label="数量"/>
              <el-table-column prop="priceType" label="价格类型">
                <template>
                  <span>***</span>
                </template>
              </el-table-column>
              <el-table-column label="定价" width="150px">
                <template>
                  <div>成本价：***</div>
                  <div>成本结算价：***</div>
                  <div>标准价：***</div>
                  <div>销售结算价：***</div>
                </template>
              </el-table-column>
              <el-table-column prop="strikePrice" label="执行价">
                <template>
                  <span>***</span>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="单价">
                <template>
                  <span>***</span>
                </template>
              </el-table-column>
              <el-table-column prop="processingFeePrice" label="加工费">
                <template>
                  <span>***</span>
                </template>
              </el-table-column>
              <el-table-column prop="total" label="金额(含税)">
                <template>
                  <span>***</span>
                </template>
              </el-table-column>
              <el-table-column prop="additionTotal" width="120" label="软硬件及配件">
                <template>
                  <span>***</span>
                </template>
              </el-table-column>
              <el-table-column prop="note" width="300" label="备注"/>
              <el-table-column prop="approveNote" label="审批意见"/>
            </el-table>
          </div>
        </div>
        <div v-if="salesOrder.salesOrderStandardMaterialVOes && salesOrder.salesOrderStandardMaterialVOes.length">
          <el-table ref="multipleTable2" :data="salesOrder.salesOrderStandardMaterialVOes" style="width: 100%; margin-top: 20px">
            <el-table-column align="center" prop="sapMaterialNo" label="物料编号"/>
            <el-table-column align="center" width="400" prop="sapMaterialDesc" label="物料描述"/>
            <el-table-column align="center" prop="quantity" label="数量"/>
            <el-table-column align="center" prop="unit" label="单位"/>
            <el-table-column align="center" prop="price" label="单价"/>
            <el-table-column align="center" prop="note" label="备注"/>
          </el-table>
        </div>
        <div v-if="salesOrder.salesOrderOtherItemVOes && salesOrder.salesOrderOtherItemVOes.length">
          <el-table ref="multipleTable2" :data="salesOrder.salesOrderOtherItemVOes" style="width: 100%; margin-top: 20px">
            <el-table-column align="center" prop="itemName" label="其他产品"/>
            <el-table-column align="center" prop="itemSpecification" label="规格型号"/>
            <el-table-column align="center" prop="itemUnit" label="单位"/>
            <el-table-column align="center" prop="quantity" label="数量"/>
            <el-table-column align="center" prop="salePrice" label="单价"/>
            <el-table-column align="center" label="金额">
              <template slot-scope="scope">
                <span>{{scope.row.quantity * scope.row.salePrice}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="note" label="备注"/>
            <el-table-column align="center" prop="approveNote" label="审批意见"/>
          </el-table>
        </div>
        <el-table ref="multipleTable3" :data="salesOrder.salesOrderExpenseVOes" style="width: 100%; margin-top: 20px">
          <el-table-column align="center" prop="expenseName" label="费用名称"/>
          <el-table-column align="center" prop="expense" label="费用">
            <template slot-scope="scope">
              <span v-if="salesOrder.priceVisible === true">{{scope.row.expense}}</span>
              <span v-else>***</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="note" label="备注"/>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="SAP销售订单明细">
        <el-table :data="salesOrder.salesOrderSAPMaterialVOes" style="width: 100%; margin-top: 20px">
          <el-table-column align="center" prop="materialNO" label="物料号">
            <template slot-scope="scope">
              <span v-if="scope.row.sapProductionOrder !== null" style="cursor: pointer;color: #2D8CF0" @click="$refs.materialDetails.open(scope.row.sapProductionOrder.pkid)">{{scope.row.materialNO}}</span>
              <span v-else>{{scope.row.materialNO}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="materialName" label="物料描述"/>
          <el-table-column align="center" prop="quantity" label="数量" width="120px"/>
          <el-table-column align="center" prop="unit" label="单位"/>
          <el-table-column label="操作" align="center" class-name="vm-table_operate" width="110px">
            <template slot-scope="scope">
              <el-button type="primary" @click="$refs.editDeliveryDate.open(scope.row.pkid)">询问交期</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="发票信息">
        <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">发票类型:</td>
            <td>{{salesOrder.invoiceType}}</td>
            <td colspan="2" rowspan="1" style="padding: 0">
              <table style="width: 100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td style="width: 30%; text-align: right; background-color: #d1e6f5; border-bottom: none">包含明细:</td>
                  <td style="width: 20%; border-bottom: none">{{salesOrder.isIncludeDetail ? "是" : "否"}}</td>
                  <td style="width: 30%; text-align: right; background-color: #d1e6f5; border-bottom: none">是否开软件:</td>
                  <td style="width: 20%; border-bottom: none">{{salesOrder.invoiceIncludeSoftware ? "是" : "否"}}</td>
                </tr>
              </table>
            </td>
            <td class="tableLabel">联络处:</td>
            <td>{{salesOrder.liaisonOffice}}</td>
          </tr>
          <tr>
            <td class="tableLabel">发票抬头:</td>
            <td style="width: 23%">{{salesOrder.invoiceName}}</td>
            <td class="tableLabel">税号:</td>
            <td style="width: 23%">{{salesOrder.invoiceVATNO}}</td>
            <td class="tableLabel">开票银行:</td>
            <td>{{salesOrder.invoiceBank}}</td>
          </tr>
          <tr>
            <td class="tableLabel">账号:</td>
            <td>{{salesOrder.invoiceAccounts}}</td>
            <td class="tableLabel">电话:</td>
            <td>{{salesOrder.invoiceTelephone}}</td>
            <td class="tableLabel">发票地址:</td>
            <td>{{salesOrder.invoiceAddress}}</td>
          </tr>
          <tr>
            <td class="tableLabel">发票备注:</td>
            <td colspan="5">{{salesOrder.invoiceNote}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="附件">
<!--        <el-button type="primary">下载所有附件</el-button>-->
        <el-table :data="salesOrder.salesOrderAttachmentVOes" style="width: 100%; margin-top: 20px">
          <el-table-column prop="fileName" label="名称" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.fileName+"."+scope.row.filePath.split(".")[1]}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="类型" align="center"/>
          <el-table-column label="下载" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
              <!--              <el-button type="danger" @click="attachmentDelete(scope.row)">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="跟踪信息">
        <div>
          <el-input type="textarea" placeholder="请输入"/>
        </div>
        <div style="margin-top: 10px; text-align: right">
          <el-button type="primary" plain icon="el-icon-upload2">上传附件</el-button>
          <el-button type="primary">回复</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
    <sales-material-edit ref="editMaterialNo"/>
    <sales-delivery-data-edit ref="editDeliveryDate"/>
    <sales-order-preview-material-details ref="materialDetails"/>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
    <el-dialog v-el-drag-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="ARD参数">
      <table v-if="show" style="width: 100%" class="ardTable" cellspacing="0">
        <tr>
          <td colspan="4" class="tdName">ARD参数表</td>
        </tr>
        <tr>
          <td class="tdName">{{ardArr[0].paramName}}</td>
          <td>
            <el-select v-model="ardArr[0].paramValue">
              <el-option label="国内项目" value="国内项目"/>
              <el-option label="国外项目" value="国外项目"/>
            </el-select>
          </td>
          <td class="tdName">{{ardArr[1].paramName}}</td>
          <td>
            <el-input v-model="ardArr[1].paramValue" placeholder="请输入"/>
          </td>
        </tr>
        <tr>
          <td class="tdName">{{ardArr[2].paramName}}</td>
          <td>
            <el-input v-model="ardArr[2].paramValue" placeholder="请输入"/>
          </td>
          <td class="tdName">{{ardArr[3].paramName}}</td>
          <td>
            <el-input v-model="ardArr[3].paramValue" placeholder="请输入"/>
          </td>
        </tr>
        <tr>
          <td class="tdName">{{ardArr[4].paramName}}</td>
          <td>
            <el-input v-model="ardArr[4].paramValue" placeholder="请输入"/>
          </td>
          <td/>
          <td/>
        </tr>
        <tr>
          <td class="tdName">{{ardArr[5].paramName}}</td>
          <td colspan="3">
            <el-input v-model="ardArr[5].paramValue" type="textarea" autosize placeholder="请输入"/>
          </td>
        </tr>
      </table>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitHandle">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import JSZip from "jszip";
// import FileSaver from "file-saver";
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import MaterialManagementSelect from "@/views/information/MaterialManagement/MaterialManagementSelect";
  import constant from "@/util/constant";
  import SalesDeliveryDataEdit from "@/views/salesManage/salesOrder/SalesDeliveryDataEdit";
  import SalesMaterialEdit from "@/views/salesManage/salesOrder/SalesMaterialEdit";
  import SalesOrderPreviewMaterialDetails from "@/views/salesManage/salesOrder/SalesOrderPreviewMaterialDetails";

  export default {
    name: "SalesOrderPreview",
    components: { SalesDeliveryDataEdit, MaterialManagementSelect, HandleDetail, SalesMaterialEdit,SalesOrderPreviewMaterialDetails },
    data() {
      return {
        dialogVisible: false,
        constant,
        loading: false,
        exportExcelOfThsInfoLoading: false,
        printSalesOrderLoading: false,
        printContractDeptLoading: false,
        printCableLoading: false,
        isHidden: false,
        billId: "0",
        billType: "0",
        salesOrder: {
          material: "",
        },
        show: false,
        ardArr: [],
      };
    },
    created() {
      this.billId = this.$route.query.billId + "";
      this.billType = this.$route.query.billType + "";
      this.getData();
    },
    methods: {
      async getData() {
        this.loading = true;
        let resp = await this.$http.get("basic", `sd/so/${this.billId}/0`);
        this.loading = false;
        this.salesOrder = resp.data;
        console.log(this.salesOrder);
        for (let item of this.salesOrder.salesOrderMaterialVOes) {
          this.$nextTick(() => {
            let list = this.getNewList(item.salesOrderMaterialPropertyVOes);
            item.salesOrderMaterialPropertyVOes = list;
          });
        }
      // this.loading = true;
      // this.$http
      //   .get("basic", `sd/so/${this.billId}/0`)
      //   .then(resp => {
      //     this.loading = false;
      //     this.salesOrder = resp.data;
      //     for (let item of this.salesOrder.salesOrderMaterialVOes) {
      //       this.$nextTick(() => {
      //         let list = this.getNewList(item.salesOrderMaterialPropertyVOes);
      //         item.salesOrderMaterialPropertyVOes = list;
      //       });
      //     }
      //   });
      },
      getNewList(list) {
        let newList = [];
        for (let item of list) {
          if (item.propertyValue !== "" && item.visible) {
            newList.push(item);
          }
        }
        return newList;
      },
      ardHandle() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$http.get("basic", `sd/ExtParam/getByTechParamBillId/${this.billId}`).then((res) => {
            if (res.success) {
              this.show = true;
              if (res.data.length) {
                this.ardArr = res.data;
              } else {
                this.ardArr = [
                  {
                    masterId: this.billId,
                    paramName: "项目类型",
                    paramValue: "国内项目",
                  },
                  {
                    masterId: this.billId,
                    paramName: "变压器输入电压",
                    paramValue: "",
                  },
                  {
                    masterId: this.billId,
                    paramName: "抱闸电压",
                    paramValue: "",
                  },
                  {
                    masterId: this.billId,
                    paramName: "曳引机类型",
                    paramValue: "",
                  },
                  {
                    masterId: this.billId,
                    paramName: "抱闸电流",
                    paramValue: "",
                  },
                  {
                    masterId: this.billId,
                    paramName: "备注信息",
                    paramValue: this.salesOrder.note,
                  },
                ];
              }
            }
          });
        });
      },
      submitHandle() {
        this.$http.post("basic", "sd/ExtParam/update", this.ardArr).then((res) => {
          if (res.success) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
          }
        });
      },
      selectMaterial(row) {
        this.salesOrder.keySAPMaterialDesc = row.no + row.name;
      },
      exportExcelOfThsInfo() {
        this.exportExcelOfThsInfoLoading = true;
        this.$http
          .exportFile("basic", `sd/so/ExportExcelOfThsInfo/${this.salesOrder.pkid}`)
          .then((res) => {
            let blob = new Blob([res.data]);
            let url = window.URL.createObjectURL(blob);
            let fileName = decodeURI(res.headers.filename);
            let a = document.createElement("a");
            a.href = url;
            if (res.headers.filename) {
              a.download = fileName;
            } else {
              a.download = "蒂升项目信息表.xlsx";
            }
            a.click();
            window.URL.revokeObjectURL(url);
            // window.open(pdfUrl);
            this.exportExcelOfThsInfoLoading = false;
          })
          .catch(() => {
            this.exportExcelOfThsInfoLoading = false;
          });
      },
      submit() {
        this.loading = true;
        this.$http
          .post("basic", "", this.department)
          .then(() => {
            this.loading = false;
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.loading = false;
          });
      },

      changeIsHidden() {
        this.loading = true;
        this.$nextTick(() => {
          for (let item of this.salesOrder.salesOrderMaterialVOes) {
            this.$refs.multipleTable.toggleRowExpansion(item, this.isHidden);
          }
          this.loading = false;
        });
        this.isHidden = !this.isHidden;
      },

      //批量下载
      // handleBatchDownload() {
      //   const zip = new JSZip();
      //   const promises = [];
      //   const cache = {};
      //   this.salesOrder.salesOrderAttachmentVOes.forEach(item => {
      //     const promise = this.getFileData(item).then(data => {
      //       const arr_name = item.fileName.split("/");
      //       const file_name = arr_name[arr_name.length - 1]; // 获取文件名
      //       zip.file(file_name, data, { binary: true }); // 逐个添加文件
      //       cache[file_name] = data;
      //     });
      //     promises.push(promise);
      //   });
      //   Promise.all(promises).then(() => {
      //     zip.generateAsync({ type: "blob" }).then(content => {
      //       // 生成二进制流
      //       FileSaver.saveAs(content, "打包下载.zip"); // 利用file-saver保存文件
      //     });
      //   });
      // },
      // getFileData(item) {
      //   let url = window.config.fileServerUrl + item.filePath.replace("~", "");
      //   return new Promise((resolve, reject) => {
      //     this.$axios({
      //       method: "",
      //       url,
      //       responseType: "blob",
      //     })
      //       .then(data => {
      //         resolve(data.data);
      //       })
      //       .catch(error => {
      //         reject(error.toString());
      //       });
      //   });
      // },
      //下载
      downLoad(row) {
        let str = row.filePath.slice(0, 1);
        if (str === "~") {
          let url = window.config.fileServerUrl + row.filePath.replace("~", "");
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        } else {
          let data = {
            name: row.fileName,
            uuid: row.filePath,
          };
          this.$http
            .exportFile("basic", "file/download", data)
            .then((res) => {
              let blob = new Blob([res.data], { type: "application" });
              let fileName = decodeURI(res.config.params.name);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
              }
              // this.downLoadLoading = false;
            })
            .catch(() => {
              // this.downLoadLoading = false;
              this.$message.error("下载失败");
            });
        }
      },
      //打印
      printSalesOrderVO() {
        let parms={
          techParamBillId:this.billId,
        };
        this.printSalesOrderLoading = true;
        this.$http.exportFile("basic", "sd/so/print",parms).then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" });
          let a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          // a.download = "可配置电子订单系统";
          a.target = "_blank";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
          this.printSalesOrderLoading = false;

          // let pdfUrl = window.URL.createObjectURL(blob);
          // window.open(pdfUrl,"可配置电子订单系统");
        });
        this.printSalesOrderLoading = false;
      },
      printContractDept() {
        let parms={
          techParamBillId:this.billId,
          nodeId:"ContractDept",
        };
        this.printContractDeptLoading = true;
        this.$http.exportFile("basic", "sd/so/print",parms).then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" });
          let a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          // a.download = "可配置电子订单系统";
          a.target = "_blank";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
          this.printContractDeptLoading = false;
          // let pdfUrl = window.URL.createObjectURL(blob);
          // window.open(pdfUrl,"可配置电子订单系统");
        })
          .catch(() => {
            this.printContractDeptLoading = false;
          });
      },
      //线缆打印
      printCable() {
        let parms={
          techParamBillId:this.billId,
          supplierNo:"S011",
        };
        this.printCableLoading = true;
        this.$http.exportFile("basic", "sd/so/print",parms).then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" });
          let a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          // a.download = "可配置电子订单系统";
          a.target = "_blank";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
          this.printCableLoading = false;
          // let pdfUrl = window.URL.createObjectURL(blob);
          // window.open(pdfUrl,"可配置电子订单系统");
        })
          .catch(() => {
            this.printCableLoading = false;
          });
      },
    // // 附件删除
    // attachmentDelete(row) {
    //   this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
    //     this.$http
    //       .delete("basic","/sd/so",row.pkid).then(() => {
    //         this.getList(-1);
    //         this.$message.success("删除成功");
    //       });
    //   });
    // },
      exportProduction(){
        this.exportExcelLoading = true;
        this.$http
            .exportFile("basic", `sAPProductionOrderDetails/exportProductionDetail/${this.billId}`)
            .then((res) => {
              let blob = new Blob([res.data]);
              let fileName = decodeURI(res.headers.filename);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
              }
              this.exportExcelLoading = false;
            })
            .catch(() => {
              this.exportExcelLoading = false;
            });
      },
    },
  };
</script>
<style lang="scss">
@media (max-width: 1280px) {
  .salesOrderPreview {
    width: 97%;
    overflow-x: scroll;
  }
}
.salesOrderPreview {
  .el-table th {
    background: #d1e6f5;
    height: 34px;
  }
  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #ebeef5;
    border-bottom: none;
    border-left: none;
  }
  table.gridtable tr td {
    padding: 8px;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #d1e6f5;
    border-left: 1px solid #ebeef5;
  }
  .el-button {
    margin-left: 0 !important;
    margin-right: 5px !important;
  }
}
.ardTable {
  tr {
    td {
      padding: 10px;
      border: 1px solid #ccc;
      border-bottom: none;
      border-right: none;
      &:last-child {
        border-right: 1px solid #ccc;
      }
    }
    &:last-child {
      td {
        border-bottom: 1px solid #ccc;
      }
    }
  }
  .tdName {
    text-align: center;
    color: #000;
    width: 100px;
  }
}
</style>
